<template>
  <div class="row" id="users">
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :apiURL="apiURL"
        :readonly="true"
        title="Documentos Permitidos"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  props: {
    id: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
    headers: [
      {
        text: 'Código',
        value: 'code',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Nombre',
        value: 'name',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'active',
        align: 'left',
        sortable: true,
      },
      // {
      //   text: 'Acciones',
      //   value: 'action',
      //   sortable: false
      // },
    ],
  }),
  mounted() {
    if (!this.can('cambiar_estado_documento_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
  },
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/documents`;
    },
  },
  components: {
    VuetifyTable,
  },
  methods: {},
};
</script>
